<template>
    <div class="container" v-if="success">
      <a-spin :spinning="loading">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <!-- <pre>{{ $data }}</pre> -->
            <strong>
              <label for="state">Seleccione su reporte :</label>
            </strong>
            <div class="d-table-cell w-100">
              <v-select 
                v-model="report"
                :clearable= "false"
                :options="reports"
              >
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.label }}
                  </div>
                </template>
              </v-select>
            </div>
            <div class="d-table-cell align-middle">
              <b-button :disabled="report === null ? true : false" @click="getReport" class="ml-1" size="sm" style="height: 2.5em;">
                <i class="fa fa-search"></i>
              </b-button>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <fieldset class="col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
            <legend>Filtros:</legend>
            <div class="row my-2">
              <!-- <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <a-range-picker v-model="date" :locale="locale" :format="dateFormat" />
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <v-select
                  v-model="office"
                  label="description"
                  :options="offices"
                  :reduce="office => office.id"
                  placeholder="Sucursal.."
                ></v-select>
              </div> -->
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <b-form-group label-for="aduana" :invalid-feedback="errors.first('aduana')" :state="!errors.has('aduana')">
                  <v-select
                    label="text"
                    v-model="aduana" 
                    :options="aduanas"
                    :reduce="aduana => aduana.id"
                    :state="errors.has('aduana') ? false : null"
                    placeholder=" Aduanas.."
                    :disabled="disabledAduana"
                  ></v-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <v-select
                  v-model="gestion"
                  label="text"
                  :options="gestiones"
                  :reduce="gestion => gestion.id"
                  placeholder=" Gestión.."
                ></v-select>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="d-flex justify-content-end pt-2"><div><strong>Total {{ items.length }} ítems</strong></div></div>
        <div v-if="items.length > 0 || Object.keys(items).length > 0" class="row mt-2">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div  class="p-2" style="background-color: #e8e8e8;">
              <b-button @click="downloadPdf" title="Descargar PDF" variant="danger" class="mr-2">
                <i class="fa fa-file-pdf-o"></i>
              </b-button>
              <!-- <b-button v-if="report.value != 'reports/get_accounts'" @click="downloadExcel" title="Descargar EXCEL" variant="success" class="mr-2">
                <i class="fa fa-file-excel-o"></i>
              </b-button> -->
            </div>
            <div v-if="report.type == 1">
              <vue-custom-scrollbar class="scroll-area">
                <div class="invoice-box">
                  <div class="car-items">
                    <template v-for="(item, index) in items">
                      <table>
                        <thead class="text-center" style="font-weight: bold;">
                          <tr :key="index">
                            <td>
                              <span style="padding-left: 10px; font-size: 20px; float:left;">Gestión {{ index }}</span>
                              <span style="padding-right: 10px; font-size: 20px; float:right;">Total Cajas: {{ item.length }}</span>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <table class="detalle">
                            <thead>
                              <tr style="background: #efefef; color: #000; text-align: center; font-weight: bold;">
                                <td width="15%">N°</td>
                                <td width="25%">Codigo Interno</td>
                                <td width="25%">Cantidad de Carpetas</td>
                                <td width="20%">Registro</td>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(row, idx) in item">
                                <tr :key="idx">
                                  <td class="text-content">{{ idx+1 }}</td>
                                  <td class="text-content">{{ row.cod_interno }}</td>
                                  <td class="text-content">{{ row.cant_carpetas }}</td>
                                  <td class="text-content">{{ row.created_at| formatDate('DD/MM/YYYY') }}</td>
                                </tr>
                              </template>
                              <tr style="background: #def5e3;">
                                  <td></td>
                                  <td style="text-align: center"><span style="font-size: 20px; font-weight: bold;">Total Carpetas:</span></td>
                                  <td style="text-align: center"><span style="font-size: 20px; font-weight: bold;">{{ totalCarpetasGestion(item) }}</span></td>
                                  <td></td>
                                </tr>
                            </tbody>
                          </table>
                        </tbody>
                      </table>
                    </template>
                  </div>
                  <div class="car-items">
                    <table>
                      <tr style="background: #7c7c7c; color: #ffffff; text-align: center; font-weight: bold;">
                        <td colspan="2">TOTALES GENERALES</td>
                      </tr>
                      <tr style="text-align: center;">
                        <td><span style="font-size: 20px; font-weight: bold;">Total Cajas:</span></td>
                        <td width="23%"><span style="font-size: 20px; font-weight: bold;">{{ totalCajasGeneral() }}</span></td>
                      </tr>
                      <tr style="text-align: center;">
                        <td><span style="font-size: 20px; font-weight: bold;">Total Carpetas:</span></td>
                        <td width="23%"><span style="font-size: 20px; font-weight: bold;">{{ totalCajasCarpetas() }}</span></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </vue-custom-scrollbar>
            </div>
            <div v-if="report.type == 2">
              <vue-custom-scrollbar class="scroll-area">
                <div class="invoice-box">
                  <div class="car-items">
                    <div class="accordion" role="tablist">
                      <b-card no-body class="mb-1" v-for="(item, index) in items" :key="index">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle="`gestion-${index}`" variant="light">
                            <div class="d-flex">
                              <div class="mr-4">
                                <span style="padding-left: 10px; font-size: 20px; float:left;">Gestión {{ index }}</span>
                              </div>
                              <div class="ml-auto">
                                <span style="padding-right: 10px; font-size: 20px; float:right;">Total Trámites: {{ item.length }}</span>
                              </div>
                            </div>
                          </b-button>
                        </b-card-header>
                        <b-collapse :id="`gestion-${index}`" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <table class="detalle">
                              <thead>
                                <tr style="background: #efefef; color: #000; text-align: center; font-weight: bold;">
                                  <td width="15%">N°</td>
                                  <td width="25%">Nro declaración</td>
                                  <td width="25%">Nro de Registro</td>
                                  <td width="20%">Aduana Trámite</td>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-for="(row, idx) in item">
                                  <tr :key="idx">
                                    <td class="text-content">{{ idx+1 }}</td>
                                    <td class="text-content">{{ row.nro_declaracion }}</td>
                                    <td class="text-content">{{ row.nro_registro }}</td>
                                    <td class="text-content">{{ row.aduana }}</td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                  <div class="car-items">
                    <table>
                      <tr style="background: #7c7c7c; color: #ffffff; text-align: center; font-weight: bold;">
                        <td colspan="2">TOTALES GENERALES</td>
                      </tr>
                      <tr style="text-align: center;">
                        <td><span style="font-size: 20px; font-weight: bold;">Total Trámites (gestiones):</span></td>
                        <td width="23%"><span style="font-size: 20px; font-weight: bold;">{{ totalCarpetasAduana }}</span></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </vue-custom-scrollbar>
            </div>
          </div>
        </div>
        <div v-else class="d-flex justify-content-center" style="background-color: #e8e8e8;">
          <div class="text-center p-2">
            <i class="fa fa-search-minus fa-3x" aria-hidden="true"></i>
            <h6>Sin Datos Disponibles</h6>
          </div>
        </div>
      </a-spin>
    </div>
  </template>
  <script>
    import { mapGetters } from 'vuex'
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import formatter from '../../mixins/formatter'
    import locale from 'ant-design-vue/es/date-picker/locale/es_ES'
    import moment from 'moment'
    import 'moment/locale/es'
    import OfficeService from '../../services/office.service'
    import ReportService from '../../services/report.service'
    import CustomerService from '../../services/customer.service'
    import UserService from '../../services/user.service'
    import AduanaService from '../../services/aduana.service'
    import TableAccountCustomer from '../../components/widgets/Tables/TableAccountCustomer.vue'
  
    export default {
      mixins: [formatter],
  
      data() {
        return {
          success: false,
          loading: false,
          locale,
          moment,
          report: null,
          reports: [
            { label: 'Total Cajas y Carpetas', value: 'reportes/total/agencia', type: 1 },
            { label: 'Trámites por aduana', value: 'reportes/aduana/agencia', type: 2},
          ],
          items: [],
          aduana: null,
          aduanas: [],
          gestion: null,
          gestiones: [
            {id: 2014, text: 'Gestion 2014'},
            {id: 2015, text: 'Gestion 2015'},
            {id: 2016, text: 'Gestion 2016'},
            {id: 2017, text: 'Gestion 2017'},
            {id: 2018, text: 'Gestion 2018'},
            {id: 2019, text: 'Gestion 2019'},
            {id: 2020, text: 'Gestion 2020'},
            {id: 2021, text: 'Gestion 2021'},
            {id: 2022, text: 'Gestion 2022'},
          ],
          totalFolders: 0,
          dateFormat: 'YYYY/MM/DD',
          date: null,
          disabledAduana: false
        }
      },
  
      components: {
        'table-account-customer': TableAccountCustomer,
        vueCustomScrollbar,
        ...mapGetters([
          'currentUser'
        ])
      },
  
      watch: {
        report: function (value) {
          if (value.type == 1) {
            this.disabledAduana = true
          } else {
            this.disabledAduana = false
          }
          this.aduana = null
          this.items = []
        },
      },
  
      computed: {
        subTotal() {
          return this.items.reduce((acc, item) => acc + Number(this.toFloat(item.monto)), 0)
        },
  
        subTotalCancelado() {
          return this.items.reduce((acc, item) => acc + Number(this.toFloat(item.cancelado)), 0)
        },
  
        subTotalSaldo() {
          return this.items.reduce((acc, item) => acc + Number(this.toFloat(item.saldo)), 0)
        },
  
        totalCarpetasAduana() {
          return Object.values(this.items).reduce(function(total, arr) {
            return total + arr.length;
          }, 0)
        },
  
        ...mapGetters([
          'currentUser'
        ])
      },
  
      created() {
        Promise.all([this.listAduanas()])
        .then(() =>{
          this.success = true
          this.$emit("general", false)
        })
      },
  
      methods: {
        totalCarpetasGestion(rows) {
          return rows.reduce((acc, item) => acc + Number(item.cant_carpetas), 0)
        },
  
        totalCajasGeneral() {
          return Object.values(this.items).flat().length
        },
  
        totalCajasCarpetas() {
          return Object.values(this.items).flat().reduce((total, item) => total + item.cant_carpetas, 0)
        },
  
        listAduanas: async function() {
          const reponse = await AduanaService.listAduanas();
          if (reponse.status === 200) {
            this.aduanas = reponse.data
          }
        },
  
        getReport: async function() {
          // this.$validator.validate().then(isTrue => {
          //   if (isTrue) {
              
          //   }
          // })
          this.loading = true
          try {
            let config = {
              method: 'post',
              url: this.report.value,
              data: {
                // initial_date: moment(this.date[0]).format('YYYY-MM-DD'),
                // final_date: moment(this.date[1]).format('YYYY-MM-DD'),
                aduana: this.aduana,
                gestion: this.gestion
              }
            }
            const response = await ReportService.getReport(config)
            if (response.status === 200) {
              this.items = response.data
              this.loading = false
            }
          } catch (err) {
            this.loading = false
          }
        },
  
        async downloadPdf() {
          try {
            this.loading = true
  
            // let items = this.items.map(obj => {
            //   let rObj = Object.assign({}, obj)
            //   if (this.report.type === 1) { 
            //     rObj.monto = Number(this.toFloat(rObj.monto))
            //     if (rObj.cancelado && rObj.saldo) {
            //       rObj.cancelado = Number(this.toFloat(rObj.cancelado))
            //       rObj.saldo = Number(this.toFloat(rObj.saldo))
            //     }
            //     return rObj
            //   }
            //   return rObj
            // })
          
            const data = {
              agency: this.currentUser.agencia, 
              title: this.reports.filter(obj => obj.value === this.report.value)[0].label, 
              // ... this.report.type === 1 && { columns: Object.keys(this.items[0]) },
              // date: { initial_date: moment(this.date[0]).format('YYYY-MM-DD'), final_date: moment(this.date[1]).format('YYYY-MM-DD') },
              type: this.report.type,
              items: this.items
            };
  
            const response = await ReportService.downloadPdf({data: data})
            if (response.status === 200) {
              // console.log(response)
              let file = new Blob([response.data], {type: 'application/pdf'})
              let fileUrl = URL.createObjectURL(file)
              window.open(fileUrl) 
              this.loading = false
            }
          } catch (err) {
            this.loading = false
            // console.log(err)
          }
        },
  
        // async downloadExcel() {
        //   try {
        //     this.loading = true
        //     const response = await ReportService.downloadExcel({data: this.items})
        //     if (response.status === 200) {
        //       let blob = new Blob([response.data])
        //       let link = document.createElement("a")
        //       link.href = window.URL.createObjectURL(blob)
        //       link.download = "Reporte.xlsx"
        //       link.click()
        //       this.loading = false
        //     }
        //   } catch (err) {
        //     this.loading = false
        //   }
        // }
      }
    }
  </script>
  <style scoped src="../../assets/css/date.css"></style>
  <style scoped>
  >>> .ant-calendar-today .ant-calendar-date {
      color: #9e0207;
      font-weight: bold;
      border-color: #9e0207;
  }
  
  >>> .b-table {
    font-size: 12px;
  }
  
  fieldset {
    background-color: #f6f6f6;
    border-radius: 4px;
  }
  
  legend {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    color: #000;
    font-size: 17px;
    font-weight: bold;
    padding: 3px 5px 3px 7px;
    width: auto;
  }
  
  .scroll-area {
    position: relative;
    margin: auto;
    height: 550px;
  }
  
  .text-content {
    text-align: center;
    font-weight: bold;
    font-size: 11pt;
  }
  
  .invoice-box {
    max-width: 100%;
    margin: auto;
    font-size: 16px;
    line-height: 24px;
    color: #555;
  }
  
  .car-items table {
    border-collapse: collapse;
    width: 100%;
  }
  
  .car-items table td, th {
    border: 1px solid #000;
    padding: 3px;
  }
  
  .car-items table thead tr {
    background: #1E692D;
    color: #fff;
  }
  </style>